// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"21":"28c22527","83":"edef7e50","186":"87eb4909","223":"160e27bf","362":"333c9d48","473":"cf249e31","595":"431f70ec","598":"6cfcf3a8","620":"0cf3cfa1","673":"c1f0c0e9","857":"e6c4adef"}[chunkId] + ".chunk.css";
};